import {
  FUEL_UNITS,
  FUEL_TYPE,
  INSIGHTS_USAGE_COLORS,
  USAGE_TYPE,
  COLOR_PALETTE_TYPE,
  USER_SEGMENT,
  USER_TYPE,
  ALLOWED_IN_MEMORY_TRANSLATIONS,
  ALLOWED_IN_MEMORY_CONFIGS,
  DEFAULT_FONT_FAMILY,
  DEFAULT_FONT_CONFIG,
  POWER_UNIT,
  UNSUPPORTED_PAGES
} from '../constants/common';
import { Configuration } from '../configs/Configuration';
import { bidgelyStorage } from './storageHelper';
import cssVars from 'css-vars-ponyfill';
import { cloneDeep } from 'lodash';
import moment from 'moment';
require("moment/min/locales.min");

let queryParamLocale = null;
let userSelectedLocale = null;

export const setUserLocaleFromQueryParam = (locale) => {
  queryParamLocale = locale;
}

export const setUserSelectedLocale = (arr) => {
  if (arr.length > 0) {
    let selectedLocaleObj = arr.filter( item => item.selected );
    if (selectedLocaleObj && selectedLocaleObj.length > 0) {
      userSelectedLocale = selectedLocaleObj[0].locale;
    }
  }
}

export const displayCost = (options) => {
    let displayCost = options.cost;
    if(options.round) {
        displayCost = Math.round(displayCost);
    }

    displayCost = formatNumber(displayCost);

    if(options.showCurrency) {
          displayCost = replaceTokens(getCurrency(), {cost: displayCost});
    }
    return displayCost;
}

export const displayUsage = (options) => {
    let displayUsage = options.usage;
    if(options.round) {
      displayUsage = Math.round(displayUsage);
    }

    displayUsage = formatNumber(displayUsage);

    if(options.showUsageUnit) {
        displayUsage += ' ' + getFuelUnit(options.fuelType);
    }
    return displayUsage;
}

export const displayPercentage = (options) => {
  if(options.round){
    return Math.round(options.percentageVal) + '%';
  }
  return options.percentageVal + '%';
}

export const displayPower = (options) => {
  let displayPower = options.value;
  if(options.round){
    displayPower = Math.round(displayPower);
  }
  displayPower = formatNumber(displayPower);

  if(options.showPowerUnit){
    displayPower += ' ' + POWER_UNIT;
  }

  return displayPower;
}

export const formatNumber = (number, withSign = false) => {
  const signs = ['-','','+'];
  let num = number;
  if(!isNaN(number)){
    let inMemConfigs = Configuration.getDatabaseConfigs();
    let defaultLocale = inMemConfigs["default_locale"];
    let split = defaultLocale.split('-');
    defaultLocale = split[0] + '-' + split[1].toUpperCase();
    num = Intl.NumberFormat(defaultLocale).format(number);
  }
  if (withSign) {
    num = signs[(Math.sign(number) + 1)] + num;
  }
  return num;
}

export const getUserLocale = (configData) => {
  let defaultLocale = configData.default_locale;
  let langToLocale = configData.language_to_locale ? JSON.parse(configData.language_to_locale) : {};

  let locale = defaultLocale.toLowerCase();
  let browserLocales = navigator.languages;
  if(browserLocales){
    for(let i = 0; i < browserLocales.length; i++){
      let isLocale = browserLocales[i].indexOf("-") != -1;
      //Check if it is a locale and a supported one, else check if it is a language and a supported one
      if(isLocale && isSupportedLocale(formatLocale(browserLocales[i]), configData)){
        locale = browserLocales[i].toLowerCase();
        break;
      } else if(!isLocale && isSupportedLanguage(browserLocales[i], configData)){
        locale = langToLocale[browserLocales[i]].toLowerCase();
        break;
      }
    }
  }
  return locale;
};

export const getBECompatibleLocale = (configData) => {
  return queryParamLocale || userSelectedLocale || formatLocale(getUserLocale(configData));
};

export const isSupportedLocale = (locale, configData) => {
  let supportedLocales = configData.supported_locale ? JSON.parse(configData.supported_locale) : [];
  supportedLocales.map((supportedLocale,index)=>{
    supportedLocales[index] = formatLocale(supportedLocale);
  })
  return supportedLocales && supportedLocales.indexOf(locale) != -1;
}

export const isSupportedLanguage = (lang, configData) => {
  let supportedLanguages = configData.supported_languages ? JSON.parse(configData.supported_languages) : [];
  return supportedLanguages && supportedLanguages.indexOf(lang) != -1;
}

export const formatLocale = (locale) => {
  let localPart = locale && locale.split("-");
  let lang = localPart && localPart.shift();
  let country = localPart && localPart.join("_").toUpperCase();
  return lang + "_" + country;
}
// This will parse response in key value value
export const parseResponse = responseData => {
    let parsedResponse = {};
    for (let i = 0; i < responseData.length; i++) {
      var config = responseData[i];
      parsedResponse[config.key] = config.val;
    }
    return parsedResponse;
};

export const replaceTokensInStrings = (originalStr, tokenMappingArray) => {
  if (originalStr && tokenMappingArray && tokenMappingArray.length) {
    for (let i = 0; i < tokenMappingArray.length; i++) {
      originalStr = originalStr.replace(new RegExp(tokenMappingArray[i].key, "g"), tokenMappingArray[i].value);
    }
  }
  return originalStr;
}

export const prepareColorsData = (colorsData, paletteType) => {
  let colorsToCssVar = {};
  let colorPaletteType = paletteType || COLOR_PALETTE_TYPE.WEB;
  if (colorsData[colorPaletteType]) {
    for (const color in colorsData[colorPaletteType]) {
      if (colorsData[colorPaletteType].hasOwnProperty(color)) {
        colorsToCssVar["--" + color] = hexToRgb(colorsData[colorPaletteType][color]);
      }
    }
  }
  replaceColorsInCss(colorsToCssVar);
}

export const replaceColorsInCss = (colorsToReplace) => {
  cssVars({
    variables: colorsToReplace
  });
  Configuration.setColors(colorsToReplace);
};

export const updateFontFamily = (fontFamilies) => {
  const fontFamilyCssVars = ['--font_family', '--font_family_secondary'];
  let variables = {};
  fontFamilies.map((fontFamily, index) => {
    variables[fontFamilyCssVars[index]] = fontFamily;
  });

  cssVars({
    variables
  });
};

export const getFontFamilies = (fontFamilies) => {
  let result = [DEFAULT_FONT_FAMILY];

  if (fontFamilies) {
    try {
      result = JSON.parse(fontFamilies);
    } catch {
    }
  }

  return result;
};

export const getFontFamiliesLoaderConfig = (fontConfig) => {
  let result = DEFAULT_FONT_CONFIG;

  if (fontConfig) {
    try {
      result = JSON.parse(fontConfig);
    } catch {
    }
  }

  return result;
};

export const getCurrency = () => {
  const translations = Configuration.getTranslations();
  return translations["DASHBOARD.CURRENCY_STRING"];
}

export const getFuelUnit = (fuelType) => {
  return fuelType === FUEL_TYPE.GAS ? FUEL_UNITS.CCF : FUEL_UNITS.kWh;
}

export const setPageTitle = (titleKey, translations, configs) => {
  if(configs["DASHBOARD.UPDATE_PAGE_TITLE"] === "true"){
    document.title  = translations["UTILITY_NAME"] + " - " + translations[titleKey];
  }
}

export const getBECompatibleFuelType = (fuelType) => {
  return fuelType.toUpperCase();
}

export const  toTitleCase = (str) => {
  return str.replace(
      /\w\S*/g,
      function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
  );
}

export const hexToRgb = (hex) => {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}`;
};

export const cloneObject = (obj) => {
  return cloneDeep(obj);
};

export const isCobrowsingMode = () => {
  return bidgelyStorage.getItem('isCobrowsing');
};

export const getApplianceColor = (applianceId) => {
  let colorData = Configuration.getColors().colors;
  return `rgb(${colorData[INSIGHTS_USAGE_COLORS[applianceId]]})`;
};

export const postMessageToIframe = (message) => {
  window.parent.postMessage(JSON.stringify(message), "*");
}
export const notifyHeightChange = (widgetId, height) => {
  postMessageToIframe({height: height, id: widgetId || ''});
}

export const getCurrentSlickRange = (current) => {
  if(window.innerWidth >= 800){
    return current+1 + '-' + (current+3);
  } else if(window.innerWidth < 800 && window.innerWidth > 550) {
    return current+1 + '-' + (current+2)
  } else {
    return current +1;
  }
}

export const getToggleUnit = (toggle, config) => {
  switch (toggle) {
    case USAGE_TYPE.COST : {
      return config.electric_cost_unit
    }
    case USAGE_TYPE.USAGE : {
      return getFuelUnit(config.fuelType.toLowerCase())
    }
    case USAGE_TYPE.PERCENTAGE : {
      return '%';
    }
  }
}

export const isEmptyObject = (obj) => {
  for(var key in obj) {
    if(obj.hasOwnProperty(key))
      return false;
  }
  return true;
}

export const replaceTokens = (text, obj) => {
  if (!text) {
    return "";
  }
  for(let key in obj) {
    if(obj.hasOwnProperty(key)) {
      let regEx = new RegExp(`{${key}}`, "g");
      let val = obj[key] + '';
      let hasDollar = false;
      //$ is special pattern in RegEx, like $1, $2, etc, so if we replace
      // {amount} with $37, Safari replaces $3 itself and just produce 7
      // so we are first replacing $ with #_# and then doing the actual
      if (val.indexOf('$') !== -1) {
        val = val.replace(/\$/g, '#_#');
        hasDollar = true;
      }
      text = text.replace(regEx, val);
      if (hasDollar) {
        text = text.replace(/#_#/g, '$');
      }
    }
  }

  return text;
};

export const getCamelCaseString = (str) => {
  return str.replace(/-([a-z])/g,  (g) => {
    return g[1].toUpperCase();
    }
  );
};

export const isNSMUser = (userType) => {
  return userType === USER_TYPE.NSM;
}

export const isSmbNsmUser = (userTypeDetails) => {
  if (!userTypeDetails) {
    return false;
  }
  let isNSM = userTypeDetails.userType === USER_TYPE.NSM;

  return isNSM && userTypeDetails.details.userSegment === USER_SEGMENT.SMB;
}

export const filterAndSetInMemConfigs = (configs) => {
  let configData = parseResponse(configs);
  let filteredConfigKeys = Object.keys(configData).filter(configKey => {
    return ALLOWED_IN_MEMORY_CONFIGS.includes(configKey);
  });
  let filteredConfigs = {};
  filteredConfigKeys.map(key => {
    filteredConfigs[key] = configData[key];
  });
  Configuration.setDatabaseConfigs(filteredConfigs);
}

export const filterAndSetInMemTranslations = (translations) => {
  let filteredTranslationKeys = Object.keys(translations).filter(translationKey => {
    return ALLOWED_IN_MEMORY_TRANSLATIONS.includes(translationKey);
  });
  let filteredTranslations ={};
  filteredTranslationKeys.map( key=> {
    filteredTranslations[key] = translations[key];
  });
  Configuration.setTranslations(filteredTranslations);
}

export const formatDate = (date, format) => {
  let inMemConfigs = Configuration.getDatabaseConfigs();
  let defaultLocale = getUserLocale(inMemConfigs);
  moment.locale(defaultLocale);
  return moment(date).format(format);
}

export const replaceEmailWithMailTo = (text) => {
  return text.replace(/([\w\.\-\pL]+@\w+\.\w+)/g, '<a href=mailto:$1>$1</a>');
}

export const isMultiFuelSupported = (measurementToUserTypeMappings) => {
  return measurementToUserTypeMappings.length > 1;
}

export const getUserType = (fuelType, measurementToUserTypeMappings) => {
  for(let i = 0; i< measurementToUserTypeMappings.length; i++){
    if(measurementToUserTypeMappings[i].measurementType.toUpperCase() === fuelType.toUpperCase()){
      return measurementToUserTypeMappings[i].userType;
    }
  }
  return measurementToUserTypeMappings[0].userType;
}

export const getDisplayAddress = (address) => {
  //trim extra spaces from address and then return first 8 characters of address
  return address.replace(/\s+/g, " ").slice(0, 8);
}

export const isPageAvailableForUser = (pathname, userType, fuelType) => {
  let unsupportedPages = UNSUPPORTED_PAGES[fuelType.toUpperCase()][userType];
  if(unsupportedPages.length){
    for(let i=0;i<unsupportedPages.length;i++){
      if(unsupportedPages[i]=== pathname){
        return false;
      }
    }
  }
  return true;
}